export default {
  filters: {
    substractDates(startDate) {
      const d = new Date();
      d.setTime(startDate * 1000);
      const today = new Date();
      const diffSeconds = (today - d) / 1000;
      let timeDiff;
      if (diffSeconds < 60) {
        return 'now';
      }
      if (diffSeconds < 3600) {
        timeDiff = Math.floor(diffSeconds / 60);
        return `About ${timeDiff} minutes`;
      }
      if (diffSeconds < 86400) {
        timeDiff = Math.floor(diffSeconds / 3600);
        return `About ${timeDiff} hours`;
      }
      if (diffSeconds < 604800) {
        timeDiff = Math.floor(diffSeconds / 3600 / 24);
        return `About ${timeDiff} days`;
      }
      if (diffSeconds < 31536000) {
        timeDiff = Math.floor(diffSeconds / 7 / 3600 / 24);
        return `About ${timeDiff} weeks`;
      }
      timeDiff = Math.floor(diffSeconds / 365 / 3600 / 24);
      return `About ${timeDiff} years`;
    }
  }
};
